/** Identifies system items that reveal the remaining items in a type-ahead section. */
export const SECTION_OVERFLOW_ITEM_KEY_SUFFIX = '--system-section-overflow';
